// src/components/songEdit/components/TagsField.tsx
import React from 'react';
import { TagInput } from '../inputs/TagInput';

interface TagsFieldProps {
  tags: string[];
  onAddTag: (tag: string) => void;
  onRemoveTag: (index: number) => void;
}

export const TagsField: React.FC<TagsFieldProps> = ({
  tags,
  onAddTag,
  onRemoveTag
}) => (
  <div className="song-form__group">
    <label className="song-form__label">Tags</label>
    <TagInput
      tags={tags}
      onAddTag={onAddTag}
      onRemoveTag={onRemoveTag}
    />
  </div>
);